import { useState, useRef, useEffect, useMemo } from "react";
import s from "./OnboardingPage.module.css";

/* ── Country data ── */
const COUNTRIES = [
  { code: "IR", flag: "\u{1F1EE}\u{1F1F7}", name: "Iran" },
  { code: "SE", flag: "\u{1F1F8}\u{1F1EA}", name: "Sweden" },
  { code: "US", flag: "\u{1F1FA}\u{1F1F8}", name: "USA" },
  { code: "GB", flag: "\u{1F1EC}\u{1F1E7}", name: "United Kingdom" },
  { code: "DE", flag: "\u{1F1E9}\u{1F1EA}", name: "Germany" },
  { code: "FR", flag: "\u{1F1EB}\u{1F1F7}", name: "France" },
  { code: "NO", flag: "\u{1F1F3}\u{1F1F4}", name: "Norway" },
  { code: "DK", flag: "\u{1F1E9}\u{1F1F0}", name: "Denmark" },
  { code: "FI", flag: "\u{1F1EB}\u{1F1EE}", name: "Finland" },
  { code: "NL", flag: "\u{1F1F3}\u{1F1F1}", name: "Netherlands" },
  { code: "ES", flag: "\u{1F1EA}\u{1F1F8}", name: "Spain" },
  { code: "IT", flag: "\u{1F1EE}\u{1F1F9}", name: "Italy" },
  { code: "TR", flag: "\u{1F1F9}\u{1F1F7}", name: "Turkey" },
  { code: "PL", flag: "\u{1F1F5}\u{1F1F1}", name: "Poland" },
  { code: "IQ", flag: "\u{1F1EE}\u{1F1F6}", name: "Iraq" },
  { code: "SY", flag: "\u{1F1F8}\u{1F1FE}", name: "Syria" },
  { code: "AF", flag: "\u{1F1E6}\u{1F1EB}", name: "Afghanistan" },
  { code: "IN", flag: "\u{1F1EE}\u{1F1F3}", name: "India" },
  { code: "CN", flag: "\u{1F1E8}\u{1F1F3}", name: "China" },
  { code: "JP", flag: "\u{1F1EF}\u{1F1F5}", name: "Japan" },
  { code: "KR", flag: "\u{1F1F0}\u{1F1F7}", name: "South Korea" },
  { code: "BR", flag: "\u{1F1E7}\u{1F1F7}", name: "Brazil" },
  { code: "CA", flag: "\u{1F1E8}\u{1F1E6}", name: "Canada" },
  { code: "AU", flag: "\u{1F1E6}\u{1F1FA}", name: "Australia" },
  { code: "EG", flag: "\u{1F1EA}\u{1F1EC}", name: "Egypt" },
  { code: "RU", flag: "\u{1F1F7}\u{1F1FA}", name: "Russia" },
  { code: "UA", flag: "\u{1F1FA}\u{1F1E6}", name: "Ukraine" },
  { code: "TH", flag: "\u{1F1F9}\u{1F1ED}", name: "Thailand" },
  { code: "PH", flag: "\u{1F1F5}\u{1F1ED}", name: "Philippines" },
  { code: "SO", flag: "\u{1F1F8}\u{1F1F4}", name: "Somalia" },
  { code: "ER", flag: "\u{1F1EA}\u{1F1F7}", name: "Eritrea" },
  { code: "ET", flag: "\u{1F1EA}\u{1F1F9}", name: "Ethiopia" },
  { code: "CL", flag: "\u{1F1E8}\u{1F1F1}", name: "Chile" },
  { code: "CO", flag: "\u{1F1E8}\u{1F1F4}", name: "Colombia" },
  { code: "MX", flag: "\u{1F1F2}\u{1F1FD}", name: "Mexico" },
  { code: "AR", flag: "\u{1F1E6}\u{1F1F7}", name: "Argentina" },
  { code: "PT", flag: "\u{1F1F5}\u{1F1F9}", name: "Portugal" },
  { code: "GR", flag: "\u{1F1EC}\u{1F1F7}", name: "Greece" },
  { code: "RO", flag: "\u{1F1F7}\u{1F1F4}", name: "Romania" },
  { code: "HU", flag: "\u{1F1ED}\u{1F1FA}", name: "Hungary" },
  { code: "CZ", flag: "\u{1F1E8}\u{1F1FF}", name: "Czech Republic" },
  { code: "AT", flag: "\u{1F1E6}\u{1F1F9}", name: "Austria" },
  { code: "CH", flag: "\u{1F1E8}\u{1F1ED}", name: "Switzerland" },
  { code: "BE", flag: "\u{1F1E7}\u{1F1EA}", name: "Belgium" },
  { code: "IE", flag: "\u{1F1EE}\u{1F1EA}", name: "Ireland" },
  { code: "NZ", flag: "\u{1F1F3}\u{1F1FF}", name: "New Zealand" },
  { code: "ZA", flag: "\u{1F1FF}\u{1F1E6}", name: "South Africa" },
  { code: "NG", flag: "\u{1F1F3}\u{1F1EC}", name: "Nigeria" },
  { code: "KE", flag: "\u{1F1F0}\u{1F1EA}", name: "Kenya" },
  { code: "PK", flag: "\u{1F1F5}\u{1F1F0}", name: "Pakistan" },
  { code: "BD", flag: "\u{1F1E7}\u{1F1E9}", name: "Bangladesh" },
  { code: "VN", flag: "\u{1F1FB}\u{1F1F3}", name: "Vietnam" },
  { code: "ID", flag: "\u{1F1EE}\u{1F1E9}", name: "Indonesia" },
  { code: "MY", flag: "\u{1F1F2}\u{1F1FE}", name: "Malaysia" },
  { code: "SG", flag: "\u{1F1F8}\u{1F1EC}", name: "Singapore" },
  { code: "IL", flag: "\u{1F1EE}\u{1F1F1}", name: "Israel" },
  { code: "LB", flag: "\u{1F1F1}\u{1F1E7}", name: "Lebanon" },
  { code: "SA", flag: "\u{1F1F8}\u{1F1E6}", name: "Saudi Arabia" },
  { code: "AE", flag: "\u{1F1E6}\u{1F1EA}", name: "UAE" },
];

/* ── Level data ── */
const LEVELS = [
  {
    id: "beginner",
    swedish: "Beginner",
    english: "",
    desc: "I don't know any Swedish yet",
    descEn: "",
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className={s.levelSvg}>
        <circle cx="24" cy="38" r="6" fill="#c9a96e" opacity="0.18" />
        <path d="M24 38V26" stroke="#8a6b22" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M24 26c-3-4-8-3-9 1" stroke="#6a9a3a" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        <path d="M24 26c3-4 8-3 9 1" stroke="#6a9a3a" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        <circle cx="24" cy="22" r="3" fill="#6a9a3a" opacity="0.25" />
      </svg>
    ),
  },
  {
    id: "some_experience",
    swedish: "Some experience",
    english: "",
    desc: "I know the basics",
    descEn: "",
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className={s.levelSvg}>
        <circle cx="24" cy="40" r="5" fill="#c9a96e" opacity="0.18" />
        <path d="M24 40V18" stroke="#5a8a2e" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M24 28c-4-5-10-3-10 2" stroke="#6a9a3a" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 22c4-5 10-3 10 2" stroke="#6a9a3a" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 18c-3-4-7-2-7 1" stroke="#7ab542" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 18c3-4 7-2 7 1" stroke="#7ab542" strokeWidth="2" strokeLinecap="round" fill="none" />
        <circle cx="24" cy="14" r="2.5" fill="#7ab542" opacity="0.3" />
      </svg>
    ),
  },
  {
    id: "intermediate",
    swedish: "Intermediate",
    english: "",
    desc: "I can hold simple conversations",
    descEn: "",
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className={s.levelSvg}>
        <ellipse cx="24" cy="42" rx="8" ry="3" fill="#c9a96e" opacity="0.15" />
        <path d="M24 42V14" stroke="#3d7a1a" strokeWidth="3" strokeLinecap="round" />
        <path d="M24 34c-6-4-12-1-11 4" stroke="#5a8a2e" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 34c6-4 12-1 11 4" stroke="#5a8a2e" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 26c-5-4-10-1-9 3" stroke="#6a9a3a" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 26c5-4 10-1 9 3" stroke="#6a9a3a" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 18c-4-3-8-1-7 2" stroke="#7ab542" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M24 18c4-3 8-1 7 2" stroke="#7ab542" strokeWidth="2" strokeLinecap="round" fill="none" />
        <circle cx="24" cy="10" r="4" fill="#7ab542" opacity="0.25" />
        <circle cx="24" cy="10" r="2" fill="#7ab542" opacity="0.4" />
      </svg>
    ),
  },
];

/* ── Referral data ── */
const REFERRALS = [
  { id: "google", label: "Google", icon: "/onboarding/came_from/google.svg" },
  { id: "salman", label: "Heard from Salman", icon: "/onboarding/came_from/salman.svg" },
  { id: "friend", label: "A friend told me", icon: "/onboarding/came_from/friends.svg" },
  { id: "social_media", label: "Social media", icon: "/onboarding/came_from/social_media.svg" },
  { id: "other", label: "Other", icon: "/onboarding/came_from/other.svg" },
];

const TOTAL_STEPS = 3;

export default function OnboardingPage({ onComplete }) {
  const [step, setStep] = useState(0);
  const [dir, setDir] = useState(1); // 1=forward, -1=backward
  const [country, setCountry] = useState("IR");
  const [level, setLevel] = useState(null);
  const [referral, setReferral] = useState(null);
  const [search, setSearch] = useState("");
  const [dropOpen, setDropOpen] = useState(false);
  const searchRef = useRef(null);
  const dropRef = useRef(null);

  const selectedCountry = COUNTRIES.find((c) => c.code === country);

  const filtered = useMemo(() => {
    if (!search) return COUNTRIES;
    const q = search.toLowerCase();
    return COUNTRIES.filter((c) => c.name.toLowerCase().includes(q));
  }, [search]);

  // close dropdown on outside click
  useEffect(() => {
    if (!dropOpen) return;
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setDropOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [dropOpen]);

  // focus search when dropdown opens
  useEffect(() => {
    if (dropOpen && searchRef.current) searchRef.current.focus();
  }, [dropOpen]);

  const canProceed =
    (step === 0 && country) ||
    (step === 1 && level) ||
    (step === 2 && referral);

  const goNext = () => {
    if (step < TOTAL_STEPS - 1) {
      setDir(1);
      setStep((s) => s + 1);
    } else {
      onComplete({ country, level, referral });
    }
  };

  const goBack = () => {
    if (step > 0) {
      setDir(-1);
      setStep((s) => s - 1);
    }
  };

  return (
    <div className={s.page}>
      {/* Decorative floating elements */}
      <div className={s.floatA} />
      <div className={s.floatB} />

      <div className={s.container}>
        {/* Step dots */}
        <div className={s.dots}>
          {Array.from({ length: TOTAL_STEPS }).map((_, i) => (
            <div
              key={i}
              className={`${s.dot} ${i === step ? s.dotActive : ""} ${i < step ? s.dotDone : ""}`}
            />
          ))}
        </div>

        {/* Step content with slide animation */}
        <div className={s.slideWrap} key={step} style={{ "--slide-dir": dir }}>
          {step === 0 && (
            <StepCountry
              country={country}
              selectedCountry={selectedCountry}
              search={search}
              setSearch={setSearch}
              dropOpen={dropOpen}
              setDropOpen={setDropOpen}
              searchRef={searchRef}
              dropRef={dropRef}
              filtered={filtered}
              onSelect={(code) => {
                setCountry(code);
                setDropOpen(false);
                setSearch("");
              }}
            />
          )}
          {step === 1 && <StepLevel level={level} setLevel={setLevel} />}
          {step === 2 && <StepReferral referral={referral} setReferral={setReferral} />}
        </div>

        {/* Navigation */}
        <div className={s.nav}>
          {step > 0 ? (
            <button className={s.backBtn} onClick={goBack} type="button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5" />
                <path d="M12 19l-7-7 7-7" />
              </svg>
              Back
            </button>
          ) : (
            <div />
          )}
          <button
            className={s.nextBtn}
            onClick={goNext}
            disabled={!canProceed}
            type="button"
          >
            {step === TOTAL_STEPS - 1 ? "Start my journey!" : "Next"}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════
   Step 1 — Country
   ═══════════════════════════════════ */
function StepCountry({
  country, selectedCountry, search, setSearch,
  dropOpen, setDropOpen, searchRef, dropRef, filtered, onSelect,
}) {
  return (
    <div className={s.stepContent}>
      <h1 className={s.title}>Where are you from?</h1>
      <p className={s.subtitle}>Help us personalize your experience</p>

      <div className={s.countryWrap} ref={dropRef}>
        <button
          className={`${s.countryTrigger} ${dropOpen ? s.countryTriggerOpen : ""}`}
          onClick={() => setDropOpen((o) => !o)}
          type="button"
        >
          <span className={s.countryFlag}>{selectedCountry?.flag}</span>
          <span className={s.countryName}>{selectedCountry?.name}</span>
          <svg className={`${s.chevron} ${dropOpen ? s.chevronUp : ""}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>

        {dropOpen && (
          <div className={s.dropdown}>
            <div className={s.searchWrap}>
              <svg className={s.searchIcon} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.3-4.3" />
              </svg>
              <input
                ref={searchRef}
                className={s.searchInput}
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search country..."
              />
            </div>
            <div className={s.countryList}>
              {filtered.map((c) => (
                <button
                  key={c.code}
                  className={`${s.countryItem} ${c.code === country ? s.countryItemActive : ""}`}
                  onClick={() => onSelect(c.code)}
                  type="button"
                >
                  <span className={s.countryItemFlag}>{c.flag}</span>
                  <span>{c.name}</span>
                  {c.code === country && (
                    <svg className={s.checkMark} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                  )}
                </button>
              ))}
              {filtered.length === 0 && (
                <p className={s.noResults}>No country found</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════
   Step 2 — Level
   ═══════════════════════════════════ */
function StepLevel({ level, setLevel }) {
  return (
    <div className={s.stepContent}>
      <h1 className={s.title}>What's your level?</h1>
      <p className={s.subtitle}>We'll tailor lessons to match you</p>

      <div className={s.levelGrid}>
        {LEVELS.map((lv, i) => (
          <button
            key={lv.id}
            className={`${s.levelCard} ${level === lv.id ? s.levelCardActive : ""}`}
            onClick={() => setLevel(lv.id)}
            type="button"
            style={{ animationDelay: `${i * 0.08 + 0.15}s` }}
          >
            <div className={s.levelIconWrap}>{lv.icon}</div>
            <div className={s.levelText}>
              <span className={s.levelSwedish}>{lv.swedish}</span>
              <span className={s.levelEnglish}>{lv.english}</span>
            </div>
            <p className={s.levelDesc}>{lv.desc}</p>
            <p className={s.levelDescEn}>{lv.descEn}</p>
          </button>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════
   Step 3 — Referral
   ═══════════════════════════════════ */
function StepReferral({ referral, setReferral }) {
  return (
    <div className={s.stepContent}>
      <h1 className={s.title}>How did you find us?</h1>
      <p className={s.subtitle}>We'd love to know what brought you here</p>

      <div className={s.referralGrid}>
        {REFERRALS.map((r, i) => (
          <button
            key={r.id}
            className={`${s.referralChip} ${referral === r.id ? s.referralChipActive : ""}`}
            onClick={() => setReferral(r.id)}
            type="button"
            style={{ animationDelay: `${i * 0.06 + 0.15}s` }}
          >
            <img className={s.referralIconImg} src={r.icon} alt="" />
            <span className={s.referralLabel}>{r.label}</span>
            {r.labelEn && <span className={s.referralLabelEn}>{r.labelEn}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
